import { useClientStore, getActiveClientId } from './client-store';

export const clientModule = {
  getCurrentId(): string | null {
    return getActiveClientId();
  },

  getCurrentName(): string {
    return useClientStore.getState().current?.name ?? '';
  },

  onChange(callback: (clientId: string) => void): () => void {
    return useClientStore.subscribe((state, prev) => {
      const id = state.current?.id ?? null;
      const prevId = prev.current?.id ?? null;
      if (id !== prevId && id != null) callback(id);
    });
  },
};
